import { Component, OnDestroy, OnInit } from "@angular/core";
import { TransitionService } from "@uirouter/core";
import { RememberService } from "../../remember/remember.service";

@Component({
  selector: "ab-unauthorized-alert",
  templateUrl: "./unauthorized.component.html",
})
export class UnauthorizedAlertComponent implements OnDestroy, OnInit {
  public show: boolean;
  private REMEMBER_KEY = "alerts.unauthorizedUrl";
  private deregisterHook: any;

  constructor(
    private rememberService: RememberService,
    private $transitions: TransitionService,
  ) {
    this.deregisterHook = this.$transitions.onSuccess({}, () => {
      // Hide the alert after any new transitions. We don't want to continue
      // showing it when it is not relevant, e.g. on a page where you DO have
      // access.
      this.hide();
    });
  }

  public ngOnDestroy() {
    if (this.deregisterHook) {
      this.deregisterHook();
    }
  }

  public ngOnInit() {
    const url = this.rememberService.get(this.REMEMBER_KEY, "") as string;
    if (this.deniedSpecificProjectAccess(url)) {
      this.show = true;
      this.forgetAlert();
    }
  }

  public hide() {
    this.show = false;
  }

  // This is a simple way to test if the reason why the user was unauthorised
  // was because they don't have project access. It works because if it was
  // because of an expired or invalid token, they would have got a 401 on an
  // earlier request before we started fetching data for the specific project.
  private deniedSpecificProjectAccess(url: string) {
    return /\/api\/v4\/projects\/\d/.test(url);
  }

  // When the app sees a 401, we redirect to /login, but we can sometimes run/
  // render this component briefly before the redirect takes affect meaning
  // that if we forget the alert immedately, it will not appear after the
  // redirect has completed. A small delay ensures the alert survives until the
  // redirect takes place.
  private forgetAlert() {
    setTimeout(() => {
      this.rememberService.forget(this.REMEMBER_KEY);
    }, 2000);
  }
}
